import { defineComponent as _defineComponent } from 'vue'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'MainListFrame',
  props: {
    hasBack: { type: Boolean, default: true },
    noSearch: { type: Boolean },
    centerBack: { type: Boolean }
  },
  emits: ["query", "reset"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'query'): void
    (e: 'reset'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { hasBack: boolean, noSearch?: boolean, centerBack?: boolean }





function onQuery() {
    emits('query')
}

function onReset() {
    emits('reset')
}

const router = useRouter()

function onKeyUp() {
    onQuery()
}


return { __sfc: true,props, emits, onQuery, onReset, router, onKeyUp }
}

})